import { ref as a, onMounted as l, watchEffect as f } from "vue";
import { dom as n } from "./index339.js";
function r(t, u) {
  if (t) return t;
  let e = u ?? "button";
  if (typeof e == "string" && e.toLowerCase() === "button") return "button";
}
function v(t, u) {
  let e = a(r(t.value.type, t.value.as));
  return l(() => {
    e.value = r(t.value.type, t.value.as);
  }), f(() => {
    var o;
    e.value || n(u) && n(u) instanceof HTMLButtonElement && !((o = n(u)) != null && o.hasAttribute("type")) && (e.value = "button");
  }), e;
}
export {
  v as useResolveButtonType
};
